<template>
  <div class="block-result-type01 result-base">
    <div class="result-body" v-if="hasResult">
      <span class="birthdate">{{userBirthdate}}</span>
      <h3>{{baseTitle}}</h3>
      <img class="result-img" v-if="!!resultImg" :src="resultImg" alt="">
      <div class="result-contents">
        <div class="image-block image-block1" v-if="resultData.result1.name1 || resultData.result1.image2 || resultData.result1.text1">
          <h4 v-if="!!resultData.result1.name1 && resultData.result1.name1.length > 0">{{resultData.result1.name1}}</h4>
          <img v-if="!!resultData.result1.image2 && resultData.result1.image2.length > 0" :src="resultData.result1.image2" alt="">
          <p v-if="!!resultData.result1.text1 && resultData.result1.text1.length > 0" v-html="resultData.result1.text1"></p>
        </div>
        <div class="image-block image-block2" v-if="resultData.result1.name2 || resultData.result1.image3 || resultData.result1.text2">
          <h4 v-if="!!resultData.result1.name2 && resultData.result1.name2.length > 0">{{resultData.result1.name2}}</h4>
          <img v-if="!!resultData.result1.image3 && resultData.result1.image3.length > 0" :src="resultData.result1.image3" alt="">
          <p v-if="!!resultData.result1.text2 && resultData.result1.text2.length > 0" v-html="resultData.result1.text2"></p>
        </div>
        <h4 v-if="lowerMenuTitle" v-html="lowerMenuTitle"></h4>
        <p class="main-text" v-if="resultData.result2.text1" v-html="resultData.result2.text1"></p>
      </div>
    </div>
    <regist-birthdate
      :is-save="true"
      :csrf-token="csrfToken"
      v-else
    />
  </div>
</template>

<script>
import RegistBirthdate from "./RegistBirthdate";

export default {
  name: 'BlockResultType03',
  components: {
    RegistBirthdate,
  },
  props: {
    baseTitle: {
      type: String,
      required: true,
    },
    lowerMenuTitle: {
      type: String,
    },
    resultData: {
      //type: Object,
      type: [Object, Array],
      default: null,
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
  },
  computed: {
    resultImg() {
      return this.hasResult && !!this.resultData.result1.image ? this.resultData.result1.image : null
    },
    hasResult() {
      return !!this.resultData && (Array.isArray(this.resultData) ? this.resultData.length > 0 : Object.keys(this.resultData).length > 0)
    },
    userBirthdate(){
      if(!!this.hasResult && !!this.resultData.birthday){
        const year = +this.resultData.birthday.substring(0, 4);
        const month = +this.resultData.birthday.substring(4, 6);
        const day = +this.resultData.birthday.substring(6);
        return `${year}年${month}月${day}日`
      }
      return ''
    },
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables";
@import "../../../../../../sass/commons/styles/fonts";

.result-base {
  background: white;
  padding: 16px 20px 50px;
  color: $col_base_black;

  .result-body {
    border: 10px solid #eded67;
    border-radius: 10px;
    padding-top: 20px;
    h3 {
      text-align: center;
      font-size: 22px;
      line-height: 34px;
      color: var(--key-color);
      margin: 0 0 20px;
    }
    h4 {
      font-size: 16px;
      font-weight: bold;
      line-height: 24px;
    }
    .result-img {
      width: 100%;
      display: block;
    }
    .result-contents{
      padding: 0 20px 20px;
      .image-block {
        border-radius: 10px;
        border: 1px solid var(--second);
        margin-bottom: 16px;
        overflow: hidden;
        img {
          width: 100%;
          display: block;
        }
        h4 {
          margin: 0;
          padding: 12px 0;
          text-align: center;
          color: white;
          font-size: 16px;
          font-weight: bold;
          line-height: 16px;
          background: var(--second);
        }
        p {
          color: var(--second);
          font-size: 18px;
          font-weight: bold;
          line-height: 26px;
          text-align: center;
        }
      }
    }

    .birthdate {
      @extend .source-han-serif-bold;
      //font-family: $title-fontfamily;
      //font-weight: 600;
      //font-style: normal;
      display: block;
      font-size: 12px;
      line-height: 24px;
      text-align: center;
      color:var(--key-color);
    }
    .result-head {

      display: flex;
      margin-bottom: 22px;
      justify-content: space-between;
      .head-item {
        cursor: pointer;
        width: calc(50% - 13px);
        user-select: none;

        .bakuro-num{
          text-align: center;
          font-style: normal;
          font-weight: 600;
          font-size: 18px;
          line-height: 24px;
          display: block;
          padding-bottom: 12px;
          transition: all 300ms ease-out 0s;
          filter:alpha(0.2);
        }
        img {
          transition: all 300ms ease-out 0s;
          filter: brightness(0.4);
          border-radius: 10px;
          display: block;
          min-height: 140px;
          height: 140px;
          margin: auto;
          margin-bottom:12px;
        }
        &.selected {
          border-bottom: 2px solid var(--second);
          color:var(--second);
          img{
            filter: brightness(1);
          }
          .bakuro-num{
            filter:none;
          }
        }
      }
    }
  }
}

.birthdate {
  //@extend .source-han-serif-bold;
  //font-family: $title-fontfamily;
  //font-weight: 600;
  //font-style: normal;
  display: block;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  color:var(--key-color);
}
/deep/ .regist-birthdate {
  background: white!important;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/houen/partials/BlockResultType03.vue